import { useDispatch, useSelector } from 'react-redux'
import {
  loadCourseActivityUserList,
  loadStudyCourseTime,
  loadStudyCourseHistory,
  loadCourseRankingAll,
  loadCourseRankingNissoken,
  loadCourseRankingCompany,
  updateBookmarkRequest
} from '../modules/course-activity/store/actions'
import reducer from '../modules/course-activity/store/reducer'
import saga from '../modules/course-activity/store/saga'
import {
  makeSelectCourseActivityUserList,
  makeSelectStudyCourseTime,
  makeSelectStudyCourseHistory,
  makeSelectCourseRankingAll,
  makeSelectCourseRankingNissoken,
  makeSelectCourseRankingCompany
} from '../modules/course-activity/store/selectors'
import { useInjectReducer, useInjectSaga } from '../store'

export const useCourseActivity = () => {
  useInjectSaga({ key: 'courseActivityStore', saga })
  useInjectReducer({ key: 'courseActivityStore', reducer })

  const dispatch = useDispatch()
  const { data: userList, isLoading: isUserListLoading } = useSelector(makeSelectCourseActivityUserList())
  const { data: studyCourseTime, isLoading: isStudyCourseTimeLoading } = useSelector(makeSelectStudyCourseTime())
  const { data: studyCourseHistory, isLoading: isStudyCourseHistoryLoading } = useSelector(makeSelectStudyCourseHistory())
  const { data: courseRankingAll, isLoading: isRankingAllLoading, isUpdatingBookmark: isUpdatingBookmarkAll } = useSelector(makeSelectCourseRankingAll())
  const { data: courseRankingNissoken, isLoading: isRankingNissokenLoading, isUpdatingBookmark: isUpdatingBookmarkNissoken } = useSelector(makeSelectCourseRankingNissoken())
  const { data: courseRankingCompany, isLoading: isRankingCompanyLoading, isUpdatingBookmark: isUpdatingBookmarkCompany } = useSelector(makeSelectCourseRankingCompany())
  const loadCourseActivityUserListAction = () => dispatch(loadCourseActivityUserList())
  const loadStudyCourseTimeAction = (payload) => dispatch(loadStudyCourseTime(payload))
  const loadStudyCourseHistoryAction = (payload) => dispatch(loadStudyCourseHistory(payload))
  const loadCourseRankingAllAction = () => dispatch(loadCourseRankingAll())
  const loadCourseRankingNissokenAction = () => dispatch(loadCourseRankingNissoken())
  const loadCourseRankingCompanyAction = () => dispatch(loadCourseRankingCompany())
  const updateBookmarkAction = (payload) => dispatch(updateBookmarkRequest(payload))

  return {
    userList,
    isUserListLoading,
    studyCourseTime,
    isStudyCourseTimeLoading,
    studyCourseHistory,
    isStudyCourseHistoryLoading,
    loadCourseActivityUserListAction,
    loadStudyCourseTimeAction,
    loadStudyCourseHistoryAction,
    courseRankingAll,
    courseRankingNissoken,
    courseRankingCompany,
    isRankingAllLoading,
    isRankingNissokenLoading,
    isRankingCompanyLoading,
    loadCourseRankingAllAction,
    loadCourseRankingNissokenAction,
    loadCourseRankingCompanyAction,
    updateBookmarkAction,
    isUpdatingBookmarkAll,
    isUpdatingBookmarkNissoken,
    isUpdatingBookmarkCompany
  }
}
